import { DataBean } from "../DataBean";

export class WorkIncentives extends DataBean {

    public async getWorkIncentivesCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
        return this.getCustomService("TalentERP", "java.util.List_getWorkIncentivesCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }

}